<form class="gap-lg grid" [formGroup]="form">
  <div hlmField>
    <label hlmFieldLabel for="select-type" labelRequired>Type de référentiel</label>
    <hlm-select id="select-type" formControlName="referentielType" placeholder="Type de référentiel à sélectionner">
      <hlm-select-trigger>
        <hlm-select-value />
      </hlm-select-trigger>
      <hlm-select-content>
        @for (type of referentielTypes | keyvalue; track type.key) {
          <hlm-option [value]="type.value">{{ type.value | convertReferentielTypeToString }}</hlm-option>
        }
      </hlm-select-content>
    </hlm-select>
  </div>
  @if (referentielType.value === referentielTypes.METIER) {
    <div hlmField>
      <label hlmFieldLabel for="select-equipe-responsable" labelRequired>Équipe Responsable</label>
      <hlm-select
        id="select-equipe-responsable"
        formControlName="equipeResponsable"
        placeholder="Institut Métier à sélectionner"
      >
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>
        <hlm-select-content>
          <hlm-select-scroll-up />
          @for (im of institutsMetier | keyvalue; track im) {
            <hlm-option [value]="im.key">{{ im.key }} - {{ im.value }}</hlm-option>
          }
          <hlm-select-scroll-down />
        </hlm-select-content>
      </hlm-select>
    </div>
  }
  <div hlmField>
    <label hlmFieldLabel for="input-nom" labelRequired>Nom du référentiel</label>
    <input id="input-nom" hlmInput type="text" formControlName="nom" />
  </div>

  @if (referentielType.value === referentielTypes.METIER) {
    <div hlmField>
      <label hlmFieldLabel for="input-code-metier" labelRequired>Code métier</label>
      <input id="input-code-metier" hlmInput type="text" formControlName="codeMetier" />
      @if (codeMetier.invalid && codeMetier.touched) {
        <hlm-field-error>Le code métier doit faire 6 caractères.</hlm-field-error>
      } @else {
        <hlm-field-description>Le code métier doit faire 6 caractères.</hlm-field-description>
      }
    </div>

    <div hlmField>
      <label hlmFieldLabel for="input-trigramme-metier" labelRequired>Trigramme métier</label>
      <input id="input-trigramme-metier" hlmInput type="text" formControlName="trigrammeMetier" />
      @if (trigrammeMetier.invalid && trigrammeMetier.touched) {
        <hlm-field-error>Le trigramme métier doit faire 3 caractères.</hlm-field-error>
      } @else {
        <hlm-field-description>Le trigramme métier doit faire 3 caractères.</hlm-field-description>
      }
    </div>
  }
</form>
